import { useEffect, useState } from 'react';
import AnalyzedContractPDFViewer from './analyzedContractPDFViewer';
import AnalyzedContractViewer from './analyzedContractViewer';

const AnalyzedContractContainer = () => {
  const [highlightedSentenceIds, setHighlightedSentenceIds] = useState<
    string[]
  >([]);
  const [isPdfLoading, setIsPdfLoading] = useState<boolean>(true);
  const [isAnalysisLoading, setIsAnalysisLoading] = useState<boolean>(true);

  useEffect(() => {
    console.log('highlight sentence ids', highlightedSentenceIds);
  }, [highlightedSentenceIds]);
  return (
    <div className="flex flex-row p-8 justify-around h-[92vh] w-full">
      <div className="relative w-[48%]">
        {isPdfLoading ? (
          <div className="pointer-events-none absolute inset-0 z-10 overflow-hidden rounded-xl border border-black bg-white">
            <div className="animate-pulse p-6">
              <div className="h-6 w-40 rounded-md bg-slate-200" />
              <div className="mt-6 h-[72vh] rounded-xl border border-slate-200 bg-slate-100" />
              <div className="mt-5 flex items-center gap-3">
                <div className="h-9 w-24 rounded-full bg-slate-200" />
                <div className="h-5 w-32 rounded-md bg-slate-200" />
                <div className="h-9 w-24 rounded-full bg-slate-200" />
              </div>
              <div className="mt-5 h-2 w-full rounded-full bg-slate-200" />
            </div>
          </div>
        ) : null}
        <AnalyzedContractPDFViewer
          highlightedSentenceIds={highlightedSentenceIds}
          onLoadingStateChange={setIsPdfLoading}
        />
      </div>

      <div
        className="relative w-[48%] rounded-xl border border-black"
      >
        {isAnalysisLoading ? (
          <div className="pointer-events-none absolute inset-0 z-10 overflow-hidden rounded-xl bg-white">
            <div className="animate-pulse p-6">
              <div className="h-8 w-56 rounded-md bg-slate-200" />
              <div className="mt-2 h-4 w-72 rounded-md bg-slate-100" />

              <div className="mt-8 grid grid-cols-1 gap-3 xl:grid-cols-2">
                <div className="rounded-2xl border border-slate-200 bg-slate-100 p-4">
                  <div className="h-5 w-40 rounded-md bg-slate-200" />
                  <div className="mt-5 flex items-end justify-between">
                    <div className="h-10 w-12 rounded-md bg-slate-200" />
                    <div className="h-4 w-12 rounded-md bg-slate-200" />
                  </div>
                </div>
                <div className="rounded-2xl border border-slate-200 bg-slate-100 p-4">
                  <div className="h-5 w-44 rounded-md bg-slate-200" />
                  <div className="mt-5 flex items-end justify-between">
                    <div className="h-10 w-12 rounded-md bg-slate-200" />
                    <div className="h-4 w-12 rounded-md bg-slate-200" />
                  </div>
                </div>
              </div>

              <div className="mt-8 space-y-5">
                <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
                  <div className="h-4 w-28 rounded-md bg-slate-200" />
                  <div className="mt-3 h-6 w-64 rounded-md bg-slate-200" />
                  <div className="mt-2 h-4 w-52 rounded-md bg-slate-100" />
                </div>

                <div className="rounded-2xl border border-slate-200 bg-slate-100 p-5">
                  <div className="h-4 w-24 rounded-md bg-slate-200" />
                  <div className="mt-3 h-7 w-56 rounded-md bg-slate-200" />
                  <div className="mt-2 h-4 w-36 rounded-md bg-slate-100" />
                  <div className="mt-5 space-y-3">
                    <div className="h-24 rounded-xl bg-white" />
                    <div className="h-24 rounded-xl bg-white" />
                    <div className="h-24 rounded-xl bg-white" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <AnalyzedContractViewer
          onSelectSentenceIds={setHighlightedSentenceIds}
          onLoadingStateChange={setIsAnalysisLoading}
        />
      </div>
    </div>
  );
};

export default AnalyzedContractContainer;
